import { type CSSProperties, type ElementType, type ReactNode } from 'react';
import clsx from 'clsx';
import { useReveal } from '@/lib/useReveal';

interface Props {
  children: ReactNode;
  delay?: number;
  as?: ElementType;
  className?: string;
  style?: CSSProperties;
  id?: string;
}

// Универсальная обёртка для входной анимации.
// Никаких motion-библиотек, только CSS-переходы + IntersectionObserver.
export default function Reveal({
  children,
  delay = 0,
  className,
  style,
  id,
  as: Tag = 'div',
}: Props) {
  const { ref, visible } = useReveal<HTMLElement>();
  const Component = Tag as ElementType;
  return (
    <Component
      ref={ref}
      id={id}
      // Без JS (краулер, отключённые скрипты) CSS-фолбэк в index.css показывает блок сразу.
      data-reveal=""
      className={clsx(
        'transition-[opacity,transform] duration-500 ease-out motion-reduce:transition-none',
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2',
        className,
      )}
      style={{ transitionDelay: `${delay}ms`, ...style }}
    >
      {children}
    </Component>
  );
}
